/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
// import { useBlockProps } from '@wordpress/block-editor';
import { useBlockProps,
	AlignmentControl,
	RichText,
	InspectorControls,
	PanelColorSettings,
	MediaUpload,
    InnerBlocks
	} from '@wordpress/block-editor';
import { useMemo , Fragment} from '@wordpress/element';

import ColorPopup from '../Components/ColorPopup';
import { generate } from 'short-uuid';

import {
	PanelBody ,
	PanelRow,
	TextControl,
	__experimentalNumberControl as NumberControl,
	__experimentalBorderBoxControl as BorderBoxControl,
	__experimentalBoxControl as BoxControl,
	RangeControl,
	ToggleControl,
	ColorPalette,
	SelectControl,
    CheckboxControl,
	Card,
	CardBody,
    CardFooter ,
	CardHeader,
	TabPanel,
	Flex, FlexBlock, FlexItem,
    ColorPicker,
    DateTimePicker,
    __experimentalAlignmentMatrixControl as AlignmentMatrixControl 
	} from '@wordpress/components';





import { GLOBAL_FONTS } from '../Global/GLOBAL_FONTS';
import { GLOBAL_FONTS_WEIGHTS } from '../Global/Global_Font_Weights';
import { GLOBAL_ICONS } from '../Global/Global_Icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen,faBookOpenReader } from '@fortawesome/free-solid-svg-icons';

import { useSelect } from '@wordpress/data';
import {withSelect} from '@wordpress/data';
import { RawHTML, useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';


/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */

function edit({ attributes, setAttributes, props }) {

    const { k2LdCoursefilterType, k2LdCoursedata, 
        K2ldItemBorderRadiusImageCG, K2ldItemWidthImageCG, K2ldItemHeightImageCG,
        K2ldItemtagBGcolorCG, K2ldItemtagSizeCG, K2ldTagFontFamCG, K2ldTagFontWeightCG, K2ldTagColorCG, K2ldTagAlignmentCG, K2ldTagWidthCG,
        K2ldTitleColorCG,K2ldItemTitleSizeCG, K2ldTitleFontFamCG, K2ldTitleFontWeightCG,
        K2ldContentColorCG,K2ldItemContentSizeCG, K2ldContentFontFamCG, K2ldContentFontWeightCG,K2ldItemContentLineHeightCG,
        K2ldLabelColorCG,K2ldItemLabelSizeCG, K2ldLabelFontFamCG, K2ldLabelFontWeightCG,K2ldLabelIconColorCG,
        K2ldButtonColorCG,K2ldItemButtonSizeCG, K2ldButtonFontFamCG, K2ldButtonFontWeightCG,
        K2ldProgressColorCG,K2ldItemProgressSizeCG, K2ldProgressFontFamCG, K2ldProgressFontWeightCG, K2ldProgressBgColorCG,
        K2ldItemPaddingCoursegrid, K2ldItemMarginCoursegrid, K2ldItemBorderCoursegrid, K2ldItemBorderRadiusCoursegrid, K2ldmainContBackgroundCoursegrid
    } = attributes;

    const k2LdcourseFilteroptions = [
        {label: 'All', value: 'all'},
        {label: 'Users', value: 'users'},
    ]
    const colorOptions = [
		{ name: 'blue', color: '#00f' },
		{ name: 'black', color: '#000' },
		{ name: 'Purple', color: '#2C2A4A' },
		{ name: 'Light Purple', color: '#4F518C' },
	]

    const onChangeK2ldItemWidthImageCG = (newVal) => {
        setAttributes({K2ldItemWidthImageCG:newVal});
    }
    const onChangeK2ldItemHeightImageCG = (newVal) => {
        setAttributes({K2ldItemHeightImageCG:newVal});
    }
    const onChangeK2ldItemBorderRadiusImageCG = (newVal) =>{
        setAttributes({K2ldItemBorderRadiusImageCG:newVal})
    }

    const ImageStyles = {
        borderTopLeftRadius: K2ldItemBorderRadiusImageCG.top,
		borderTopRightRadius: K2ldItemBorderRadiusImageCG.right,
		borderBottomRightRadius: K2ldItemBorderRadiusImageCG.bottom,
		borderBottomLeftRadius: K2ldItemBorderRadiusImageCG.left,
        width: K2ldItemWidthImageCG + "%",
        height: K2ldItemHeightImageCG +"px"
    }

    const onChangeK2ldItemtagBGcolorCG = (newVal) => {
        setAttributes({K2ldItemtagBGcolorCG:newVal})
    }

    const onChangeK2ldItemtagSizeCG = (newVal) => {
        setAttributes({K2ldItemtagSizeCG:newVal})
    }

    const onChangeK2ldTagFontFamCG = (newVal) =>{
        setAttributes({K2ldTagFontFamCG: newVal})
    }

    const onChangeK2ldTagFontWeightCG = (NewVal) => {
        setAttributes({K2ldTagFontWeightCG:NewVal})
    }

    const onChangeK2ldTagColorCG = (newVal) => {
        setAttributes({K2ldTagColorCG:newVal})
    }
    const onChangeK2ldTagAlignmentCG = (newVal) => {
        setAttributes({K2ldTagAlignmentCG:newVal})   
    }

    const onChangeK2ldTagWidthCG = (Val) => {
        setAttributes({K2ldTagWidthCG: Val})
    }
    let tagStyles = {
        background: K2ldItemtagBGcolorCG,
        fontSize: K2ldItemtagSizeCG + "px",
        fontWeight: K2ldTagFontWeightCG,
        fontFamily: K2ldTagFontFamCG,
        color: K2ldTagColorCG,
        width: K2ldTagWidthCG+'%'
    }

    if(K2ldTagAlignmentCG === 'top left'){
        tagStyles.top="20px";
        tagStyles.left="20px";
        tagStyles.right="auto";
    }
    else if(K2ldTagAlignmentCG === 'top center'){
        tagStyles.top="20px";
        tagStyles.left="0";
        tagStyles.right="0";
        tagStyles.margin="0 auto";

    }
    else if(K2ldTagAlignmentCG === 'top right' ){
        tagStyles.top="20px";
        tagStyles.left="auto";
        tagStyles.right="20px";
    }
    else if(K2ldTagAlignmentCG === 'center left'){
        tagStyles.top="44%";
        tagStyles.left="20px";
        tagStyles.right="auto";
    }
    else if(K2ldTagAlignmentCG === 'center center'){
        tagStyles.top="40%";
        tagStyles.left="0";
        tagStyles.right="0";
        tagStyles.margin="0 auto";
    }
    else if(K2ldTagAlignmentCG === 'center right'){
        tagStyles.top="44%";
        tagStyles.left="auto";
        tagStyles.right="20px";
    }
    else if(K2ldTagAlignmentCG === 'bottom left' ){
        tagStyles.bottom="20px";
        tagStyles.left="20px";
        tagStyles.right="auto";
    }
    else if(K2ldTagAlignmentCG === 'bottom center'){
        tagStyles.bottom="20px";
        tagStyles.left="0";
        tagStyles.right="0";
        tagStyles.margin="0 auto";
    }
    else if( K2ldTagAlignmentCG === 'bottom right' ){
        tagStyles.bottom="20px";
        tagStyles.left="auto";
        tagStyles.right="20px";
    }
    else{
        null;
    }

    const onChangeK2ldItemTitleSizeCG = (newVal) => {
        setAttributes({K2ldItemTitleSizeCG:newVal})
    }

    const onChangeK2ldTitleFontFamCG = (newVal) =>{
        setAttributes({K2ldTitleFontFamCG: newVal})
    }

    const onChangeK2ldTitleFontWeightCG = (NewVal) => {
        setAttributes({K2ldTitleFontWeightCG:NewVal})
    }

    const onChangeK2ldTitleColorCG = (newVal) => {
        setAttributes({K2ldTitleColorCG:newVal})
    }
   
    let TitleStyles = {
        fontSize: K2ldItemTitleSizeCG + "px",
        fontWeight: K2ldTitleFontWeightCG,
        fontFamily: K2ldTitleFontFamCG,
        color: K2ldTitleColorCG
    }

    const onChangeK2ldItemContentSizeCG = (newVal) => {
        setAttributes({K2ldItemContentSizeCG:newVal})
    }

    const onChangeK2ldContentFontFamCG = (newVal) =>{
        setAttributes({K2ldContentFontFamCG: newVal})
    }

    const onChangeK2ldContentFontWeightCG = (NewVal) => {
        setAttributes({K2ldContentFontWeightCG:NewVal})
    }

    const onChangeK2ldContentColorCG = (newVal) => {
        setAttributes({K2ldContentColorCG:newVal})
    }

    const onChangeK2ldItemContentLineHeightCG = (val) => {
        setAttributes({K2ldItemContentLineHeightCG:val})
    }
   
    let ContentStyles = {
        fontSize: K2ldItemContentSizeCG + "px",
        fontWeight: K2ldContentFontWeightCG,
        fontFamily: K2ldContentFontFamCG,
        color: K2ldContentColorCG,
        lineHeight: K2ldItemContentLineHeightCG+'rem'
    }

    const onChangeK2ldItemLabelSizeCG = (newVal) => {
        setAttributes({K2ldItemLabelSizeCG:newVal})
    }

    const onChangeK2ldLabelFontFamCG = (newVal) =>{
        setAttributes({K2ldLabelFontFamCG: newVal})
    }

    const onChangeK2ldLabelFontWeightCG = (NewVal) => {
        setAttributes({K2ldLabelFontWeightCG:NewVal})
    }

    const onChangeK2ldLabelColorCG = (newVal) => {
        setAttributes({K2ldLabelColorCG:newVal})
    }
   
    let LabelStyles = {
        fontSize: K2ldItemLabelSizeCG + "px",
        fontWeight: K2ldLabelFontWeightCG,
        fontFamily: K2ldLabelFontFamCG,
        color: K2ldLabelColorCG
    }

    const onChangeK2ldLabelIconColorCG = (val) =>{
        setAttributes({K2ldLabelIconColorCG:val})
    }

    let LabeliconStyles = {
        color:K2ldLabelIconColorCG
    }

    const onChangeK2ldItemButtonSizeCG = (newVal) => {
        setAttributes({K2ldItemButtonSizeCG:newVal})
    }

    const onChangeK2ldButtonFontFamCG = (newVal) =>{
        setAttributes({K2ldButtonFontFamCG: newVal})
    }

    const onChangeK2ldButtonFontWeightCG = (NewVal) => {
        setAttributes({K2ldButtonFontWeightCG:NewVal})
    }

    const onChangeK2ldButtonColorCG = (newVal) => {
        setAttributes({K2ldButtonColorCG:newVal})
    }
   
    let ButtonStyles = {
        fontSize: K2ldItemButtonSizeCG + "px",
        fontWeight: K2ldButtonFontWeightCG,
        fontFamily: K2ldButtonFontFamCG,
        color: K2ldButtonColorCG
    }

    const onChangeK2ldItemProgressSizeCG = (newVal) => {
        setAttributes({K2ldItemProgressSizeCG:newVal})
    }

    const onChangeK2ldProgressFontFamCG = (newVal) =>{
        setAttributes({K2ldProgressFontFamCG: newVal})
    }

    const onChangeK2ldProgressFontWeightCG = (NewVal) => {
        setAttributes({K2ldProgressFontWeightCG:NewVal})
    }

    const onChangeK2ldProgressColorCG = (newVal) => {
        setAttributes({K2ldProgressColorCG:newVal})
    }
   
    let ProgressStyles = {
        fontSize: K2ldItemProgressSizeCG + "px",
        fontWeight: K2ldProgressFontWeightCG,
        fontFamily: K2ldProgressFontFamCG,
        color: K2ldProgressColorCG
    }

    const onChangeK2ldProgressBgColorCG = (newVal) => {
        setAttributes({K2ldProgressBgColorCG:newVal})
    }
           
    const onChangek2LdCoursefilterType = (newVal) => {
        setAttributes({k2LdCoursefilterType:newVal})
    }

    const onChangeK2ldItemPaddingCoursegrid = (newVal) => {
        setAttributes({K2ldItemPaddingCoursegrid:newVal})
    }
    const onChangeK2ldItemMarginCoursegrid = (newVal) => {
        setAttributes({K2ldItemMarginCoursegrid:newVal})
    }
    const onChangeK2ldItemBorderCoursegrid = (newVal) => {
        setAttributes({K2ldItemBorderCoursegrid:newVal})
    }
    const onChangeK2ldItemBorderRadiusCoursegrid = (newVal) => {
        setAttributes({K2ldItemBorderRadiusCoursegrid:newVal})
    }
    const onChangeK2ldmainContBackgroundCoursegrid = (newVal) => {
        setAttributes({K2ldmainContBackgroundCoursegrid:newVal})
    }

    const cardDescriptionStyles = {
        paddingTop: K2ldItemPaddingCoursegrid.top,
		paddingRight: K2ldItemPaddingCoursegrid.right,
		paddingBottom: K2ldItemPaddingCoursegrid.bottom,
		paddingLeft: K2ldItemPaddingCoursegrid.left,
        marginTop: K2ldItemMarginCoursegrid.top,
		marginRight: K2ldItemMarginCoursegrid.right,
		marginBottom: K2ldItemMarginCoursegrid.bottom,
		marginLeft: K2ldItemMarginCoursegrid.left,
        borderColor: K2ldItemBorderCoursegrid.color,
        borderStyle: K2ldItemBorderCoursegrid.style,
        borderWidth: K2ldItemBorderCoursegrid.width,
        borderTopLeftRadius: K2ldItemBorderRadiusCoursegrid.top,
		borderTopRightRadius: K2ldItemBorderRadiusCoursegrid.right,
		borderBottomRightRadius: K2ldItemBorderRadiusCoursegrid.bottom,
		borderBottomLeftRadius: K2ldItemBorderRadiusCoursegrid.left,
        background: K2ldmainContBackgroundCoursegrid
    }

    useEffect(() => {
        if (k2LdCoursefilterType){
            var path = "/wp/v1/k2learndash/coursegrid?post_type=sfwd-courses&k2LdCoursefilterType="+k2LdCoursefilterType;
            wp.apiFetch({
                path: path
            }).then((k2learndash) => {
                    setAttributes({
                        k2LdCoursedata: k2learndash
                    });
                    console.log("Final Output:",k2LdCoursedata)
            })
            .catch((error) => {
                console.error('Error fetching k2LdCoursedata:', error);
            });

        }
			
	}, [k2LdCoursefilterType]);

    const [isNarrow, setIsNarrow] = useState(false);

    useEffect(() => {
        const containerMain = document.querySelector('.k2_ld_course_grid_parent_container');

        const checkWidth = () => {
            if (containerMain.offsetWidth < 810) {
                setIsNarrow(true);
            } else {
                setIsNarrow(false);
            }
        };

        // Initial check
        checkWidth();

        // Create a ResizeObserver instance
        const resizeObserver = new ResizeObserver(() => {
            checkWidth();
        });

        // Start observing the container
        resizeObserver.observe(containerMain);

        // Cleanup observer on component unmount
        return () => {
            resizeObserver.unobserve(containerMain);
        };
    }, []);
    
    return(
        <div {...useBlockProps()}>
            <div className={`k2_ld_course_grid_parent_container ${isNarrow ? 'narrow' : ''}`}>
                {k2LdCoursedata.map((course, index) => (
                    <div key={index} className='k2_ld_course_grid_item'>
                        <div className="k2_ld_course_image">
                            {course.image_url && <img src={course.image_url} alt={course.title} style={ImageStyles} />}
                            <div className="k2_ld_course_image_tag" style={tagStyles}>
                                {
                                    course.user_course_status != null ?
                                        course.user_course_status === 'not_started' ?
                                            'Not Started'
                                        :
                                        course.user_course_status === 'in_progress' ?
                                            'In Progress'
                                        :
                                        'Completed'
                                    :
                                    course.course_type === 'free' ?
                                    'Free'
                                    :
                                    course.course_type === 'paynow' ?
                                    'Buy Now'
                                    :
                                    'Open'
                                    
                                }
                                
                            </div>
                        </div>
                        <div className="k2_ld_course_description_cont" style={cardDescriptionStyles} >
                            <h5 style={TitleStyles}>{course.title}</h5>
                            <p className="course_excerpt" style={ContentStyles}>{course.course_des}</p>
                            <div className="k2_ld_lessons_container">
                                <div className="k2_ld_lessons_info">
                                <FontAwesomeIcon icon={faBookOpen} style={LabeliconStyles} />
                                    <p style={LabelStyles}>{course.number_of_lessons.length} Lessons</p>
                                </div>
                                <div className="k2_ld_student_info">
                                    <FontAwesomeIcon icon={faBookOpenReader} style={LabeliconStyles} />
                                    <p style={LabelStyles} >{course.number_of_students.length} Students</p>
                                </div>
                            </div>
                            <div className="k2_ld_course_button_container">
                                {course.completion_percentage != null ?
                                    <a style={ButtonStyles} href={course.permalink} >
                                        Get Started
                                    </a>
                                    :
                                    <a href={course.permalink} >
                                        {course.course_type === 'free' ?
                                            'Enroll Today'
                                        :
                                            course.course_type === 'paynow' ?
                                            'Buy Now'
                                        :
                                            'See more'
                                        }
                                    </a>
                                }
                               
                            </div>
                            {course.completion_percentage != null &&
                                <div>
                                    <div className="k2_course_progress_bar_container">
                                        <div class="k2_course_grid_progress_line" style={{width: course.completion_percentage +'%', backgroundColor: K2ldProgressBgColorCG}}></div>
                                    </div>
                                    <div class="k2_course_progress_text">
                                        <span style={ProgressStyles} >{course.completion_percentage +'%'} complete</span>
                                    </div>
                                </div>
                            }  
                           
                        </div>
                    </div>
                ))}
            </div>
            <InspectorControls>
                <PanelBody title={__("Course Filers")} initialOpen={true} >
                    <Card>
                        <CardHeader>
                            <label>Select Filter</label>
                        </CardHeader>
                        <CardBody>
                            <SelectControl 
                                value={k2LdCoursefilterType}
                                options={ k2LdcourseFilteroptions }
                                onChange={onChangek2LdCoursefilterType}
                            />
                        </CardBody>
                    </Card>
                    
                </PanelBody>
                <PanelBody title={__("Media")} initialOpen={false}>
                    <Card>
                        <CardHeader>Image Size</CardHeader>
                        <CardBody>
                            <RangeControl 
                                label="Height"
                                value={K2ldItemHeightImageCG}
                                max = {1000}
                                onChange={onChangeK2ldItemHeightImageCG}
                            />
                            <RangeControl 
                                label="Width"
                                value={K2ldItemWidthImageCG}
                                onChange={onChangeK2ldItemWidthImageCG}
                            />
                        </CardBody>
                        <CardHeader>Radius</CardHeader>
                        <CardBody>
                            <BoxControl 
                                label="border radius"
                                value={K2ldItemBorderRadiusImageCG}
                                onChange={onChangeK2ldItemBorderRadiusImageCG}
                            />
                        </CardBody>
                    </Card>
                </PanelBody>
                <PanelBody title={__("Tag")} initialOpen={false} >
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                label={"Background Color"}
                                value={{ value: onChangeK2ldItemtagBGcolorCG}}
                                onChange = {onChangeK2ldItemtagBGcolorCG}
                                PropertyName={"backgroundColor"}
                            />

                            <RangeControl 
                                label='Width'
                                value={K2ldTagWidthCG}
                                onChange = {onChangeK2ldTagWidthCG}

                            />

                            <RangeControl 
                                label='Font Size'
                                value={K2ldItemtagSizeCG}
                                onChange = {onChangeK2ldItemtagSizeCG}

                            />
                            <Flex>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Family"
                                        value={K2ldTagFontFamCG}
                                        options={ GLOBAL_FONTS }
                                        onChange={onChangeK2ldTagFontFamCG}

                                    />
                                </FlexItem>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Weight"
                                        value={K2ldTagFontWeightCG}
                                        options={ GLOBAL_FONTS_WEIGHTS }
                                        onChange={onChangeK2ldTagFontWeightCG}

                                    />
                                </FlexItem>
                            </Flex>
                            <ColorPopup 
                                label={"Text color"}
                                value={{ value:K2ldTagColorCG}}
                                onChange = {onChangeK2ldTagColorCG}
                                PropertyName={"backgroundColor"}
                            />
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader>Alignment</CardHeader>
                        <CardBody>
                            <AlignmentMatrixControl
                                value={ K2ldTagAlignmentCG }
                                onChange={ onChangeK2ldTagAlignmentCG }
                            />
                        </CardBody>
                    </Card>
                </PanelBody>
                <PanelBody title={__("Title")} initialOpen={false} >
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                    label={"Text color"}
                                    value={{ value:K2ldTitleColorCG}}
                                    onChange = {onChangeK2ldTitleColorCG}
                                    PropertyName={"color"}
                            />
                            <RangeControl 
                                label='Font Size'
                                value={K2ldItemTitleSizeCG}
                                onChange = {onChangeK2ldItemTitleSizeCG}

                            />
                            <Flex>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Family"
                                        value={K2ldTitleFontFamCG}
                                        options={ GLOBAL_FONTS }
                                        onChange={onChangeK2ldTitleFontFamCG}

                                    />
                                </FlexItem>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Weight"
                                        value={K2ldTitleFontWeightCG}
                                        options={ GLOBAL_FONTS_WEIGHTS }
                                        onChange={onChangeK2ldTitleFontWeightCG}

                                    />
                                </FlexItem>
                            </Flex>
                        </CardBody>
                        
                    </Card>
                </PanelBody>
                <PanelBody title={__("Content")} initialOpen={false} >
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                    label={"Text color"}
                                    value={{ value:K2ldContentColorCG}}
                                    onChange = {onChangeK2ldContentColorCG}
                                    PropertyName={"color"}
                            />
                            <RangeControl 
                                label='Font Size'
                                value={K2ldItemContentSizeCG}
                                onChange = {onChangeK2ldItemContentSizeCG}

                            />
                            <Flex>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Family"
                                        value={K2ldContentFontFamCG}
                                        options={ GLOBAL_FONTS }
                                        onChange={onChangeK2ldContentFontFamCG}

                                    />
                                </FlexItem>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Weight"
                                        value={K2ldContentFontWeightCG}
                                        options={ GLOBAL_FONTS_WEIGHTS }
                                        onChange={onChangeK2ldContentFontWeightCG}

                                    />
                                </FlexItem>
                            </Flex>
                            <RangeControl 
                                label='Line height'
                                step={0.5}
                                value={K2ldItemContentLineHeightCG}
                                onChange = {onChangeK2ldItemContentLineHeightCG}

                            />

                        </CardBody>
                        
                    </Card>
                </PanelBody>
                <PanelBody title={__("Label")} initialOpen={false} >
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                    label={"Text color"}
                                    value={{ value:K2ldLabelColorCG}}
                                    onChange = {onChangeK2ldLabelColorCG}
                                    PropertyName={"color"}
                            />
                            <RangeControl 
                                label='Font Size'
                                value={K2ldItemLabelSizeCG}
                                onChange = {onChangeK2ldItemLabelSizeCG}

                            />
                            <Flex>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Family"
                                        value={K2ldLabelFontFamCG}
                                        options={ GLOBAL_FONTS }
                                        onChange={onChangeK2ldLabelFontFamCG}

                                    />
                                </FlexItem>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Weight"
                                        value={K2ldLabelFontWeightCG}
                                        options={ GLOBAL_FONTS_WEIGHTS }
                                        onChange={onChangeK2ldLabelFontWeightCG}

                                    />
                                </FlexItem>
                            </Flex>

                        </CardBody>
                        
                    </Card>
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                    label={"Icon color"}
                                    value={{ value:K2ldLabelIconColorCG}}
                                    onChange = {onChangeK2ldLabelIconColorCG}
                                    PropertyName={"color"}
                            />
                        </CardBody>
                        
                    </Card>
                </PanelBody>
                <PanelBody title={__("Button")} initialOpen={false} >
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                    label={"Text color"}
                                    value={{ value:K2ldButtonColorCG}}
                                    onChange = {onChangeK2ldButtonColorCG}
                                    PropertyName={"color"}
                            />
                            <RangeControl 
                                label='Font Size'
                                value={K2ldItemButtonSizeCG}
                                onChange = {onChangeK2ldItemButtonSizeCG}

                            />
                            <Flex>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Family"
                                        value={K2ldButtonFontFamCG}
                                        options={ GLOBAL_FONTS }
                                        onChange={onChangeK2ldButtonFontFamCG}

                                    />
                                </FlexItem>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Weight"
                                        value={K2ldButtonFontWeightCG}
                                        options={ GLOBAL_FONTS_WEIGHTS }
                                        onChange={onChangeK2ldButtonFontWeightCG}

                                    />
                                </FlexItem>
                            </Flex>

                        </CardBody>
                        
                    </Card>
                </PanelBody>
                <PanelBody title={__("Progress")} initialOpen={false} >
                    <Card>
                        <CardBody>
                            <ColorPopup 
                                    label={"Text color"}
                                    value={{ value:K2ldProgressColorCG}}
                                    onChange = {onChangeK2ldProgressColorCG}
                                    PropertyName={"color"}
                            />
                            <RangeControl 
                                label='Font Size'
                                value={K2ldItemProgressSizeCG}
                                onChange = {onChangeK2ldItemProgressSizeCG}

                            />
                            <Flex>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Family"
                                        value={K2ldProgressFontFamCG}
                                        options={ GLOBAL_FONTS }
                                        onChange={onChangeK2ldProgressFontFamCG}

                                    />
                                </FlexItem>
                                <FlexItem>
                                    <SelectControl
                                        label="Font Weight"
                                        value={K2ldProgressFontWeightCG}
                                        options={ GLOBAL_FONTS_WEIGHTS }
                                        onChange={onChangeK2ldProgressFontWeightCG}

                                    />
                                </FlexItem>
                            </Flex>

                        </CardBody>
                        
                    </Card>
                    <Card>
                        <CardBody>
                        <ColorPopup 
                                label={"Progress color"}
                                value={{ value:K2ldProgressBgColorCG}}
                                onChange = {onChangeK2ldProgressBgColorCG}
                                PropertyName={"backgroundColor"}
                            />
                        </CardBody>
                    </Card>
                </PanelBody>
                <PanelBody title={__("Background")} initialOpen={false}>
                    
                    <Card>
                        <CardHeader>
                            Card Background
                        </CardHeader>
                        <CardBody>
                            <ColorPopup 
                                label={"Background Color"}
                                value={{ value: K2ldmainContBackgroundCoursegrid}}
                                onChange = {onChangeK2ldmainContBackgroundCoursegrid}
                                PropertyName={"backgroundColor"}
                            />
                        </CardBody>
                        <CardHeader>
                            Card Spacing
                        </CardHeader>
                        <CardBody className="k2-custom-carbody-styles">
                            <BoxControl
                                label="Padding"
                                value={K2ldItemPaddingCoursegrid}
                                onChange={onChangeK2ldItemPaddingCoursegrid}
                            />
                            <BoxControl
                                label="Margin"
                                value={K2ldItemMarginCoursegrid}
                                onChange={onChangeK2ldItemMarginCoursegrid}
                            />
                            <hr />
                            <BorderBoxControl 
                                label="Borders"
                                onChange={onChangeK2ldItemBorderCoursegrid}
                                value={K2ldItemBorderCoursegrid}
                                colors = {colorOptions}
                                
                            />
                            <BoxControl 
                                label="border radius"
                                value={K2ldItemBorderRadiusCoursegrid}
                                onChange={onChangeK2ldItemBorderRadiusCoursegrid}
                            />
                        </CardBody>
                        
                    </Card>
                </PanelBody>
                


            </InspectorControls>
        </div>
    );

}

export default edit;
